import * as React from 'react';
import cx from 'classnames';
import styles from './styles.css';
/**
 * Обертка для элементов форм, которая позволяет указать лейбл и ошибку
 *
 * Имеет внешний отступ снизу, который можно отключить
 */
export var FormField = /*#__PURE__*/React.forwardRef(function FormField(props, ref) {
  var label = props.label,
    errorMessage = props.errorMessage,
    required = props.required,
    withoutMargin = props.withoutMargin,
    children = props.children;
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: cx(styles['field'], !!label && styles['hasLabel'], !!errorMessage && styles['hasError'], !!withoutMargin && styles['withoutMargin'])
  }, label && /*#__PURE__*/React.createElement("label", {
    className: cx(styles['label'], !!required && styles['required'])
  }, label), children, errorMessage && /*#__PURE__*/React.createElement("div", {
    className: styles['error']
  }, errorMessage));
});